
/**
 * 상품 타입
 */
export type GetOrders200OrdersItemItemType = typeof GetOrders200OrdersItemItemType[keyof typeof GetOrders200OrdersItemItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOrders200OrdersItemItemType = {
  COURSE: 'COURSE',
  EBOOK: 'EBOOK',
  SERVICE: 'SERVICE',
  SUBSCRIPTION: 'SUBSCRIPTION',
  DIGITAL_GOODS: 'DIGITAL_GOODS',
  OTHER: 'OTHER',
} as const;
